import * as React from "react";
import { SVGProps } from "../types";

const WesternUnionIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle cx="16" cy="16" r="14" fill="#0B0006"></circle>
    <path
      fill="#FFFDFE"
      d="M4 12h.635l2.478 8.75h-.635zM5.715 12h.636l2.478 8.75h-.636z"
    ></path>
    <path
      fill="#FEDB32"
      d="M9.337 12H7.43l2.478 8.75h1.906l1.693-5.687 1.801 5.687h1.81L19.504 12h-1.875l-1.482 5.594L14.42 12h-1.811l-1.716 5.497zM19.503 16.063 20.583 12h.826v5.563c0 .828.682 1.5 1.524 1.5h.636c.842 0 1.525-.672 1.525-1.5V12H27v5.563C27 19.46 25.435 21 23.505 21h-.508c-1.93 0-3.494-1.539-3.494-3.437z"
    ></path>
  </svg>
);

export { WesternUnionIcon };
